// Small helper for formatting account balances / P/L in whichever currency
// the account is denominated in (USD or EUR today). This is DISPLAY ONLY —
// backend stores the actual `currency` field on each trading account.
const SYMBOL = { USD: '$', EUR: '€' };
const LOCALE = { USD: 'en-US', EUR: 'de-DE' };

export const currencySymbol = (code) => SYMBOL[(code || 'USD').toUpperCase()] || '$';

export const formatMoney = (amount, code = 'USD') => {
  const c = (code || 'USD').toUpperCase();
  const n = Number(amount);
  if (!Number.isFinite(n)) return `${SYMBOL[c] || '$'}0.00`;
  try {
    return new Intl.NumberFormat(LOCALE[c] || 'en-US', {
      style: 'currency',
      currency: c,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${SYMBOL[c] || '$'}${n.toFixed(2)}`;
  }
};

// Account figures arrive as null when the backend could not convert them with a validated FX rate.
export const formatMetric = (amount, code = 'USD') => (amount === null ? 'Unavailable' : formatMoney(amount, code));
